import { render, staticRenderFns } from "./client_view.vue?vue&type=template&id=4a56d5c3&"
import script from "./client_view.vue?vue&type=script&lang=js&"
export * from "./client_view.vue?vue&type=script&lang=js&"
import style0 from "./client_view.vue?vue&type=style&index=0&id=4a56d5c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports